import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { withTranslation } from 'react-i18next';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import ReactPlayer from 'react-player';
import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';
import './style.scss';

const rightArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-right';
const leftArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-left';

const GalleryComponent = ({ fields = {}, i18n, params }) => {
  const { items } = fields;

  const shouldRenderItems = Array.isArray(items) && items.length > 0;

  const [selectedItem, setSelectedItem] = useState(0);

  const swiperRef = useRef();

  const renderImageOrVideo = () => {
    let galleryImage;
    let galleryVideo;
    let galleryVideoYT;
    let galleryVideoVimeo;

    if (shouldRenderItems) {
      const item = items[selectedItem]?.fields;
      if (item?.galleryImage?.value?.src) {
        galleryImage = item?.galleryImage;
      } else if (item?.galleryVideo?.value?.href) {
        galleryVideo = item?.galleryVideo;
      } else if (item?.youtubeId?.value) {
        galleryVideoYT = item?.youtubeId;
      } else if (item?.vimeoId?.value) {
        galleryVideoVimeo = item?.vimeoId;
      }
    }
    if (galleryImage) {
      return <Image field={galleryImage} />;
    } else if (galleryVideo) {
      return (
        <ReactPlayer
          url={galleryVideo.value.href}
          loop={false}
          controls={true}
          volume={5}
          muted={false}
          playing={false}
          playsinline={true}
        />
      );
    } else if (galleryVideoYT) {
      return (
        <ReactPlayer
          url={`//www.youtube.com/embed/${galleryVideoYT?.value}`}
          loop={false}
          controls={true}
          volume={5}
          muted={false}
          playing={false}
          playsinline={true}
        />
      );
    } else if (galleryVideoVimeo) {
      return (
        <iframe
          src={`//player.vimeo.com/video/${galleryVideoVimeo?.value}?autoplay=1&loop=1&title=0&byline=0&portrait=0`}
          frameBorder="0"
          allowFullScreen
          sandbox
        />
      );
    }
    return null;
  };

  const goLeft = () => {
    if (selectedItem === 0) return;
    swiperRef.current.swiper.slideTo(selectedItem - 1);
    setSelectedItem((prev) => --prev);
  };

  const goRight = () => {
    if (selectedItem === items?.length - 1) return;
    swiperRef.current.swiper.slideTo(selectedItem + 1);
    setSelectedItem((prev) => ++prev);
  };

  return (
    shouldRenderItems && (
      <div className={clsx('gallery-component', 'add-margins', params?.Styles)}>
        <div className="main-gallery-image_video">{renderImageOrVideo()}</div>
        {items?.length > 1 && (
          <>
            <div
              role="button"
              onClick={goLeft}
              className={clsx(
                'gallery-component-slider-control d-sm-none',
                selectedItem === 0 && 'remove-control'
              )}
            >
              <img src={leftArrow} alt="arrow" />
            </div>
            <div
              role="button"
              onClick={goRight}
              className={clsx(
                'gallery-component-slider-control right-control d-sm-none',
                selectedItem === items?.length - 1 && 'remove-control'
              )}
            >
              <img src={rightArrow} alt="arrow" />
            </div>
            <Swiper
              ref={swiperRef}
              slidesPerView={'auto'}
              slidesPerGroup={1}
              className="gallery-component-slider"
              spaceBetween={8}
              dir={i18n.language === 'en' ? 'ltr' : 'rtl'}
            >
              {items.map((item, index) => {
                let thumbnail;
                if (item?.fields?.galleryImageThumbnail?.value?.src) {
                  thumbnail = item?.fields?.galleryImageThumbnail;
                } else if (item?.fields?.galleryImage?.value?.src) {
                  thumbnail = item?.fields?.galleryImage;
                }
                return (
                  <SwiperSlide key={index} className="gallery-component-slider_single">
                    <Image field={thumbnail} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <div className="gallery-component-slider-controls d-none d-sm-flex">
              <div
                role="button"
                onClick={goLeft}
                className={clsx(
                  'gallery-component-slider-control',
                  selectedItem === 0 && 'disabled-control'
                )}
              >
                <img src={leftArrow} alt="arrow" />
              </div>
              <div
                role="button"
                onClick={goRight}
                className={clsx(
                  'gallery-component-slider-control right-control',
                  selectedItem === items?.length - 1 && 'disabled-control'
                )}
              >
                <img src={rightArrow} alt="arrow" />
              </div>
              <div className="gallery-component-slider-progress">
                <span className="current">{selectedItem + 1}</span>
                <span className="total"> / </span>
                <span className="total">{items?.length}</span>
              </div>
            </div>
          </>
        )}
      </div>
    )
  );
};

export default withTranslation()(GalleryComponent);
